<template>
	<div v-if="logoType == 'logo'" class="logo">
		<router-link :to="url">
			<img class="logo-light" :src="lightLogo" alt="Corporate Logo" />
			<img class="logo-dark" :src="darkLogo" alt="Corporate Logo" />
		</router-link>
	</div>

	<div v-else-if="logoType == 'qcode'" class="logo">		
			<img class="logo-light" :src="qcodeLogo" alt="Qcode Logo" />
	</div>
</template>

<script>
	export default {
		name: 'Logo',
		props: {
			logoType: {
				type: String,
				default: 'logo'
			},
			url: {
				type: String,
				default: '/'
			},
			lightLogo: {
				type: String,
				default: function() {
					return require(`@/assets/images/edge/Logo-BlackWhite.png`)
				}
			},
			darkLogo: {
				type: String,
				default: function() {
					return require(`@/assets/images/edge/edge_heng_logo.png`)
				}
			},
			qcodeLogo: {
				type: String,
				default: function() {
					return require(`@/assets/images/edge/qcode_small.jpg`)
				}
			}
		}
	}
</script>
